import { memo } from 'react';

import { UploadIcon } from '@air/design-icons';
import { Button, type ButtonProps } from '@air/primitive-button';
import { DropdownMenu, type DropdownMenuOption, renderDropdownItems } from '@air/primitive-dropdown-menu';
import { IconButton } from '@air/primitive-icon-button';

export type UploadDropdownButtonProps = {
  appearance?: ButtonProps['appearance'];
  color?: ButtonProps['color'];
  /** Icon-only trigger. `label` becomes the accessible name. */
  iconOnly?: boolean;
  label?: string;
  options: DropdownMenuOption[];
};

export const UploadDropdownButton = memo(
  ({
    appearance = 'filled',
    color = 'grey',
    iconOnly = false,
    label = 'Upload a file',
    options,
  }: UploadDropdownButtonProps) => {
    if (!options.length) {
      return null;
    }

    return (
      <DropdownMenu
        trigger={
          iconOnly ? (
            <IconButton
              adsIcon
              appearance={appearance}
              color={color}
              data-testid="UPLOAD_DROPDOWN_BUTTON"
              icon={UploadIcon}
              label={label}
              size="medium"
            />
          ) : (
            <Button
              appearance={appearance}
              color={color}
              data-testid="UPLOAD_DROPDOWN_BUTTON"
              prefix={<UploadIcon size="sm" />}
              size="medium"
            >
              {label}
            </Button>
          )
        }
      >
        {renderDropdownItems({ options, size: 'small' })}
      </DropdownMenu>
    );
  },
);

UploadDropdownButton.displayName = 'UploadDropdownButton';
